import React from 'react';

/**
 * 品牌标识：简洁莲花（金色描边，currentColor 继承）。
 * 用于导航栏与登录卡的站名前缀，呼应「云上净土」主题。
 */
const BrandIcon = ({ size = 28, className, style }) => (
  <svg
    className={className}
    style={style}
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    {/* 中心花瓣 */}
    <path d="M16 6c1.9 2.3 2.9 4.9 2.9 7.6 0 2-.9 3.7-2.9 5.2-2-1.5-2.9-3.2-2.9-5.2 0-2.7 1-5.3 2.9-7.6Z" />
    {/* 内侧左右花瓣 */}
    <path d="M16 18.8c-2.2-.9-4.5-1-6.6-.2-.6 2 .1 4 1.9 5.4 2 1.4 3.6 1.3 4.7.4" />
    <path d="M16 18.8c2.2-.9 4.5-1 6.6-.2.6 2-.1 4-1.9 5.4-2 1.4-3.6 1.3-4.7.4" />
    {/* 外侧左右花瓣 */}
    <path d="M13.1 19.6c-2.6-1.5-5.3-2-8-1.3.2 2.4 1.7 4.4 4.3 5.3 2 .7 3.6.4 4.6-.4" />
    <path d="M18.9 19.6c2.6-1.5 5.3-2 8-1.3-.2 2.4-1.7 4.4-4.3 5.3-2 .7-3.6.4-4.6-.4" />
    {/* 水面 */}
    <path d="M6 26.5c2 .9 4 .9 6 0 2 .9 4 .9 6 0 2 .9 4 .9 6 0" opacity="0.7" />
  </svg>
);

export default BrandIcon;
